import React from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";

const UserActionDropdown = ({
  onViewDetails,
  onManageUser,
  tempRemoval,
  border = "border-none shadow-none",
}) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton
          className={`inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ${border}`}
        >
          <EllipsisVerticalIcon className="h-7 w-7 font-thin text-sm text-gray-300" />
        </MenuButton>
      </div>

      <MenuItems className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div className="py-1">
          {tempRemoval ? null :
            <MenuItem>
              {({ active }) => (
                <button
                  onClick={onViewDetails}
                  className={`block w-full px-4 py-2 text-left text-sm ${active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                    }`}
                >
                  View Details
                </button>
              )}
            </MenuItem>}

          <MenuItem>
            {({ active }) => (
              <button
                onClick={onManageUser}
                className={`block w-full px-4 py-2 text-left text-sm ${active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                  }`}
              >
                Manage User
              </button>
            )}
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
};

export default UserActionDropdown;
